var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "no-gutters": "",
      "justify": "end",
      "justify-xl": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "line-height-1",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "x-small": "",
      "color": "grey-6",
      "to": "/center"
    }
  }, [_c('span', {
    staticClass: "font-weight-regular"
  }, [_vm._v("고객센터")])])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', {
    staticClass: "menu-line"
  })]), _c('v-col', {
    staticClass: "line-height-1",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "x-small": "",
      "color": "grey-6",
      "to": "/form/inquiry-partner"
    }
  }, [_c('span', {
    staticClass: "font-weight-regular"
  }, [_vm._v("기업회원 채용지원")])])], 1), _vm.accessToken ? [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', {
    staticClass: "menu-line"
  })]), _c('v-col', {
    staticClass: "line-height-1",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "x-small": "",
      "color": "grey-6",
      "to": "/mypage/question"
    }
  }, [_c('span', {
    staticClass: "font-weight-regular"
  }, [_vm._v("문의하기")])])], 1)] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }